import { useState } from "react";
import { Button } from "@/components/ui/button";
import { MessageCircle } from "lucide-react";
import { FeedbackModal } from "./FeedbackModal";
import { useQuery } from "@tanstack/react-query";
import { useParams } from "wouter";

export function FloatingFeedbackButton() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const params = useParams();
  const projectId = params?.id || params?.projectId;

  // Get current user context
  const { data: userContext } = useQuery({
    queryKey: ['/api/auth/user/simonshah4@gmail.com'],
    enabled: false, // We'll use header-based auth
  });

  // Extract user email from headers or context
  const userEmail = 'simonshah4@gmail.com'; // This would typically come from auth context
  const userName = (userContext as any)?.user?.username || 'User';

  // Determine current module based on URL
  const getCurrentModule = () => {
    const path = window.location.pathname;
    if (path.includes('/maturity')) return 'Maturity Assessment';
    if (path.includes('/value')) return 'Value Engineering';
    if (path.includes('/benchmarking')) return 'Benchmarking';
    if (path.includes('/roi')) return 'ROI Analysis';
    if (path.includes('/admin')) return 'Admin Panel';
    if (path.includes('/project')) return 'Project Management';
    return 'General';
  };

  return (
    <>
      {/* Floating Feedback Button */}
      <div className="fixed bottom-6 right-6 z-50">
        <Button
          onClick={() => setIsModalOpen(true)}
          className="h-12 w-12 rounded-full shadow-lg hover:shadow-xl transition-all duration-200 bg-transparent border-white border-2 hover:bg-primary/90 text-white"
          size="icon"
          title="Send Feedback"
        >
          <MessageCircle className="h-5 w-5" />
        </Button>
      </div>

      {/* Feedback Modal */}
      <FeedbackModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        userEmail={userEmail}
        userName={userName}
        projectId={projectId}
        module={getCurrentModule()}
      />
    </>
  );
}